import { render } from "./InvertColors.vue?vue&type=template&id=9c297c42&scoped=true"
import script from "./InvertColors.vue?vue&type=script&lang=js"
export * from "./InvertColors.vue?vue&type=script&lang=js"

import "./InvertColors.vue?vue&type=style&index=0&id=9c297c42&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c297c42"]])

export default __exports__